import React, { useState } from 'react';
import { Task } from '../api/api';
import TaskModal from './TaskModal';
import './TaskCard.css';

interface TaskCardProps {
  task: Task;
  onUpdate: () => void;
}

const TaskCard: React.FC<TaskCardProps> = ({ task, onUpdate }) => {
  const [showModal, setShowModal] = useState(false);

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'open':
        return '#3498db';
      case 'in_review':
        return '#9b59b6';
      case 'completed':
        return '#27ae60';
      default:
        return '#95a5a6';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'open':
        return 'Открыта';
      case 'in_review':
        return 'На проверке';
      case 'completed':
        return 'Завершена';
      default:
        return status;
    }
  };

  return (
    <>
      <div className="task-card" onClick={() => setShowModal(true)}>
        <div className="task-card-header">
          <h3>{task.title}</h3>
          <span
            className="status-badge"
            style={{ backgroundColor: getStatusColor(task.status) }}
          >
            {getStatusText(task.status)}
          </span>
        </div>
        {task.description && (
          <p className="task-description">{task.description}</p>
        )}
        <div className="task-card-footer">
          <div className="task-meta">
            <span>Создал: {task.created_by_username || 'Неизвестно'}</span>
            {task.assigned_to_username && (
              <span>Исполнитель: {task.assigned_to_username}</span>
            )}
            {task.deadline && (
              <span 
                style={{ 
                  color: new Date(task.deadline) < new Date() ? '#e74c3c' : '#666',
                  fontWeight: new Date(task.deadline) < new Date() ? 'bold' : 'normal'
                }}
              >
                Дедлайн: {new Date(task.deadline).toLocaleString('ru-RU')}
                {new Date(task.deadline) < new Date() && ' (Просрочено)'}
              </span>
            )}
          </div>
          <div className="task-stats">
            {task.comments && task.comments.length > 0 && (
              <span className="stat">💬 {task.comments.length}</span>
            )}
            {task.attachments && task.attachments.length > 0 && (
              <span className="stat">📎 {task.attachments.length}</span>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <TaskModal
          taskId={task.id}
          onClose={() => {
            setShowModal(false);
          }}
          onTaskUpdated={onUpdate}
        />
      )}
    </>
  );
};

export default TaskCard;


